import MenuLayout from './Layout'
import AppsList from './Apps/List'
import MenusList from './Menus/List'
import SubMenusList from './SubMenus/List'

export default [
  {
    path: 'menu',
    alias: '',
    component: MenuLayout,
    redirect: '/menu/apps',
    name: 'MenuModule',
    meta: {
      breadcrumb: 'Menús y Apps'
    },
    children: [
      {
        path: 'apps',
        alias: '',
        component: AppsList,
        name: 'AppsList',
        meta: {
          breadcrumb: 'Apps'
        }
      },
      {
        path: 'apps/:app_id/menus',
        alias: '',
        component: MenusList,
        name: 'MenusList',
        meta: {
          breadcrumb: 'Menús'
        }
      },
      {
        path: 'apps/:app_id/menus/:menu_id/sub_menus',
        alias: '',
        component: SubMenusList,
        name: 'SubMenusList',
        meta: {
          breadcrumb: 'Submenús'
        }
      }
    ]
  }]
